"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceUserActionEnum = void 0;
var UserServiceUserActionEnum;
(function (UserServiceUserActionEnum) {
  /** Могу изменить общие сведения */
  UserServiceUserActionEnum["edit"] = "edit";
  /** Могу записаться на занятие/серию занятий */
  UserServiceUserActionEnum["signup"] = "signup";
  /** Могу запланировать занятие/серию занятий */
  UserServiceUserActionEnum["schedule"] = "schedule";
  /** Могу архивировать */
  UserServiceUserActionEnum["archive"] = "archive";
  /** Могу восстановить из архива */
  UserServiceUserActionEnum["restore"] = "restore";
})(UserServiceUserActionEnum = exports.UserServiceUserActionEnum || (exports.UserServiceUserActionEnum = {}));
